/* iter55g60 — Editor keyboard + focus effects.
 *
 * Bundles the small side-effects that used to live in EditorPanel:
 *   1. Cmd/Ctrl+F opens the in-panel Search drawer.
 *   2. Blank-canvas ref auto-focuses when opening an empty chapter so
 *      the writer can start typing without an extra click.
 *   3. Keeps useSpellCheck's own open flag in sync with the drawer
 *      registry so EditorDrawers can uniformly toggle it.
 */
import { useEffect } from 'react';

export function useEditorShortcuts({
  drawers,
  spellOpen,
  blankCanvasRef,
  chapterId,
}) {
  // Cmd/Ctrl+F → search drawer
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'f') {
        e.preventDefault();
        drawers.open('search');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [drawers]);

  // Sync spell drawer state with useSpellCheck's own flag.
  useEffect(() => {
    if (spellOpen && !drawers.spellOpen) drawers.setOpen('spell', true);
  }, [spellOpen, drawers]);

  // Auto-focus blank canvas when a new empty chapter opens.
  useEffect(() => {
    if (!blankCanvasRef.current) return;
    const t = window.setTimeout(() => {
      try { blankCanvasRef.current?.focus(); } catch { /* noop */ }
    }, 80);
    return () => window.clearTimeout(t);
  }, [chapterId, blankCanvasRef]);
}
